import { createContext, useContext } from 'react';

export const AdminContext = createContext({
  notify: () => {},
  confirm: async () => false,
  changed: () => {},
});

export const useAdmin = () => useContext(AdminContext);
